import { render, staticRenderFns } from "./CampaignVisual.vue?vue&type=template&id=19f5e45a&scoped=true&"
import script from "./CampaignVisual.vue?vue&type=script&lang=js&"
export * from "./CampaignVisual.vue?vue&type=script&lang=js&"
import style0 from "./CampaignVisual.vue?vue&type=style&index=0&id=19f5e45a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f5e45a",
  null
  
)

export default component.exports